export default __webpack_public_path__ + "static/media/recorte_4.8b394af0.JPG";